import React, { useEffect, useRef, useState, Children } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import isDesktopSelector from 'store/app/selector/isDesktop';
import CarouselLeftArrow from './CarouselLeftArrow/CarouselLeftArrow';
import CarouselRightArrow from './CarouselRightArrow/CarouselRightArrow';
import styles from './Carousel.module.scss';
import CarouselIndicators from './CarouselIndicators/CarouselIndicators';

export const SCROLL_TOLERANCE = 50;

export interface OwnProps {
  children: React.ReactNode;
  extraData?: any;
  className?: string;
  showIndicators?: boolean;
  theme?: string;
}

const Carousel = ({ children, extraData, className, showIndicators, theme }: OwnProps) => {
  const carouselEl = useRef<HTMLDivElement>(null);
  const isDesktop = useSelector(isDesktopSelector);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [currentScrollIndex, setCurrentScrollIndex] = useState(0);
  const [reRender, reRenderNow] = useState(0);
  const onSectionScroll = (event: any) => {
    setScrollOffset(event.nativeEvent.target.scrollLeft);
  };

  const scrollTo = (index: number) => {
    setCurrentScrollIndex(index);
    carouselEl.current &&
      carouselEl.current.scrollTo({
        behavior: 'smooth',
        left: carouselEl.current.offsetWidth * index,
      });
  };

  useEffect(() => {
    setTimeout(() => {
      reRenderNow(reRender + 1);
    }, 300);
  }, [children]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={cn(styles.carouselContainer, className)} {...extraData}>
      {isDesktop && (
        <CarouselLeftArrow scrollArea={carouselEl} scrollOffset={scrollOffset} theme={theme}>
          {theme === 'studio' ? <span className={styles.left} /> : <BsChevronLeft />}
        </CarouselLeftArrow>
      )}
      <div className={styles.carousel} ref={carouselEl} onScroll={onSectionScroll}>
        <div className={styles.carouselItems}>{children}</div>
      </div>
      {isDesktop && (
        <CarouselRightArrow scrollArea={carouselEl} scrollOffset={scrollOffset} theme={theme}>
          {theme === 'studio' ? <span className={styles.right} /> : <BsChevronRight />}
        </CarouselRightArrow>
      )}
      {showIndicators && (
        <CarouselIndicators length={Children.count(children)} onScroll={scrollTo} current={currentScrollIndex} />
      )}
    </div>
  );
};

export default Carousel;
